export default {
	showJobsCategory: [],
	showRefferalCategory: [],
	showJobFairCategory: [],
	showAdvertisementCategory: [],
	showAppliedJobs: [],
	showMatchingJobs: [],
	showSubscribeJobFairCategory: [],
	dashboardAnalytics: [],
}